const ColorList={
    "Blues": "White to dark blue",
"Reds": "White to dark red",
"Greens": "White to dark green",
"Purples": "White to dark purple",
"Oranges": "White to dark orange",
"Greys": "White to black",
"YlOrBr": "Light yellow to dark brown",
"YlOrRd": "Light yellow to dark red",
"OrRd": "Light orange to dark red",
"PuRd": "Light purple to dark red",
"BuPu": "Light blue to dark purple",
"GnBu": "Light green to dark blue",
"PuBu": "Light purple to dark blue",
"YlGnBu": "Light yellow to dark blue-green",
"YlGn": "Light yellow to dark green",
"PiYG": "Pink to dark green",
"PRGn": "Pink to dark green",
"BrBG": "Brown to dark green",
"PuOr": "Light purple to dark orange",
"RdGy": "Red to gray",
"RdBu": "Red to blue",
"RdYlBu": "Red to yellow to blue",
"RdYlGn": "Red to yellow to green",
"Spectral": "Rainbow from blue to red",
"coolwarm": "Blue to red transition",
"bwr": "Blue to white to red",
"seismic": "Blue to red (seismic)",
"viridis": "Yellow to purple (uniform)",
"plasma": "Dark purple to bright yellow",
"inferno": "Black to bright yellow (flame)",
"magma": "Dark red to light purple"
    }
export default ColorList